import { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import { useSelector } from "react-redux"
import { formatDinero } from "./../../../utils/formatDinero"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import ButtonVoucher from "../ButtonVoucher"
const columns = [
    { id: "cliente", minWidth: 150, align: "center", label: "Cliente" },
    { id: "monto", minWidth: 150, align: "center", label: "Monto" },
    { id: "referencia", minWidth: 150, align: "center", label: "Referencia" },
    { id: "tipoCompra", minWidth: 150, align: "center", label: "Tipo Compra" },
    { id: "voucher", minWidth: 150, align: "center", label: "Voucher" },
]

const useStyles = makeStyles({
    root: {
        width: "100%",
        marginTop: "15px",
    },
    container: {
        maxHeight: 440,
    },
})

export default function TablaEgresosMxn() {
    const { metricaEgresos } = useSelector(store => store.reportes)
    const rows = metricaEgresos?.lDetEgresoMXN ?? []
    console.log("🚀 ~ TablaEgresosMxn ~ rows:", rows)
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                        <TableCell align="center">
                                            {row?.NomCliente}
                                        </TableCell>
                                        <TableCell align="center">
                                            {formatDinero(row?.Monto)} MXN
                                        </TableCell>
                                        <TableCell align="center">
                                            <ButtonClienteDetalle
                                                referencia={row?.Referencia}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.TipoCompra?.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                row?.lVoucher.map((voucherId, index) =>
                                                    <ButtonVoucher key={voucherId} idVoucher={voucherId} tipoCompra={row?.TipoCompra?.idTipoCompra} />
                                                )
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}
